'use es6';

import { createSelector } from 'reselect';
import { getTracksAreRequesting } from './trackSelectors';
import { getLessonsAreRequesting } from './lessonSelectors';
export const getIsRequestingTracksOrLessons = createSelector(state => state, getTracksAreRequesting, getLessonsAreRequesting, (_, ...values) => values.some(v => v));